/* global mapData */
Wee.fn.extend('identoMap', {
	/**
	 * Init search
	 *
	 * @param {object} options
	 * @param {string} [options.mapUrl=null] Map url where data is posted to
	 */
	initSearch: function(options) {
		var priv = this.$private;

		priv.searchConf = $.extend({}, options);

		priv.initResultsApp();
		priv.bindInput();
		priv.bindInputClear();
		priv.bindResultsMouseEvent();

		// Load map locations if they are posted
		if (typeof mapData !== 'undefined' && mapData) {
			mapData.features = JSON.parse(mapData.features);
			mapData.hidden = true;

			priv.searchResultsApp.$set(mapData);
			priv.queryForLocations();

			mapData = null;
		}
	},
	unloadSearch: function() {
		$.events.off(false, '.mapSearch');
	}
}, {
	/**
	 * Init search results app
	 *
	 * @private
	 */
	initResultsApp: function() {
		var scope = this;

		scope.searchResultsApp = $.app.make('mapSearchResults', {
			target: 'ref:mapSearchResults',
			view: 'idento-map.search-results',
			model: {
				active: 0,
				hidden: true,
				selected: null,
				features: null
			}
		});

		scope.searchResultsApp.$observe('selected', function(data) {
			scope.clearError();

			if (data !== null) {
				if (scope.searchConf.mapUrl) {
					scope.postForLocations();
				} else {
					scope.queryForLocations();
				}

				scope.searchResultsApp.$set('hidden', true);
				scope.searchResultsApp.$set('active', 0);
			}
		});
	},

	/**
	 * Bind search input
	 *
	 * @private
	 */
	bindInput: function() {
		var scope = this,
			app = scope.searchResultsApp;

		$.events.on({
			'ref:mapSearchInput': {
				'keydown': function(e, el) {
					var features = app.$get('features');

					clearTimeout(scope.searchTimeout);

					scope.searchTimeout = setTimeout(function() {
						var val = $(el).val();

						if (! val) {
							$('ref:mapSearchClear').hide();
						}

						if ($.screen.size() < 3) {
							$('ref:mapSidebar').addClass('-is-scrolled');
						}

						if (! scope.isInvalidKey(e)) {
							scope.clearError();
							scope.queryFromInput(val);
						}
					}, 200);

					if (features && features.length && ! app.$get('hidden')) {
						scope.cycleThroughResults(e);
						scope.enterKeySelect(e);
					} else if (e.keyCode === 13) {
						scope.clearError();
						scope.queryFromInput($(el).val());
					}

					e.stopPropagation();
				},
				'blur': function() {
					if ($.screen.size() > 2) {
						app.$set('hidden', true);
						app.$set('active', 0);
					}
				},
				'focus': function() {
					scope.clearError();

					if ($.screen.size() < 3) {
						$('ref:mapSidebar').addClass('-is-scrolled');
					}

					app.$set('hidden', false);
				}
			}
		}, {
			namespace: 'mapSearch'
		});

		// Blur input when scrolling through search results
		$($._doc).on('touchstart.mapSearch', function() {
			if ($.screen.size() < 3) {
				$('ref:mapSearchInput')[0].blur();
			}
		});
	},

	/**
	 * Check if key is invalid
	 *
	 * @private
	 * @param {object} e
	 * @returns {boolean}
	 */
	isInvalidKey: function(e) {
		// Keys: Tab, Esc, Left, Right, Enter, Up, Down
		var keyCodes = [
			9,
			27,
			37,
			39,
			13,
			38,
			40
		];

		return e.metaKey || keyCodes.indexOf(e.keyCode) !== -1;
	},

	/**
	 * Query location search from input
	 *
	 * @private
	 * @param {string} q
	 */
	queryFromInput: function(q) {
		var query = q.trim();

		if (! query) {
			this.clearResults();
		}

		if (query.length > 2) {
			this.geocode(q);
		}
	},

	/**
	 * Geocode query
	 *
	 * @private
	 * @param {string} q
	 */
	geocode: function(q) {
		var scope = this,
			pub = scope.$public,
			app = scope.searchResultsApp;

		scope.toggleLoadingState(true);

		app.$set('hidden', false);

		Wee.api.get({
			url: pub.apiEndpoint + q + '.json',
			data: {
				country: 'us',
				access_token: pub.accessToken,
				types: 'region,postcode,place'
			},
			success: function(response) {
				scope.toggleLoadingState(false);

				if (! response.features.length) {
					scope.applyError('No results found. Please try your search again.');
				} else {
					app.$set({
						active: 0,
						features: response.features
					});
				}

				scope.searchTimeout = null;
			},
			error: function(xhr) {
				scope.toggleLoadingState(false);

				scope.applyError(scope.formatStatusText(xhr.statusText));
			}
		});
	},

	/**
	 * Clear search results
	 *
	 * @private
	 */
	clearResults: function() {
		var $input = $('ref:mapSearchInput'),
			app = this.searchResultsApp;

		$('ref:mapSearchClear').hide();

		$input.val('');
		$input[0].focus();

		app.$set('features', null);
		app.$set('active', 0);

		$('ref:mapSidebar').removeClass('-is-scrolled');
	},

	/**
	 * Bind search clear button
	 *
	 * @private
	 */
	bindInputClear: function() {
		var scope = this;

		$('ref:mapSearchClear').on('click.mapSearch', function() {
			scope.clearResults();
		});
	},

	/**
	 * Cycle through search results
	 *
	 * @private
	 * @param {object} e
	 * @returns {boolean}
	 */
	cycleThroughResults: function(e) {
		// Keys: Up and Down
		var keyCodes = [
				38,
				40
			],
			app = this.searchResultsApp,
			code = e.keyCode,
			features = app.$get('features'),
			currentSelection = app.$get('active'),
			count;

		// If up or down arrows are not pressed
		if (keyCodes.indexOf(code) === -1) {
			return false;
		}

		count = features.length - 1;

		// If up arrow
		if (code === keyCodes[0]) {
			currentSelection > 0 ?
				app.$set('active', currentSelection - 1) :
				app.$set('active', count);
		}

		// If down arrow
		if (code === keyCodes[1]) {
			currentSelection < count ?
				app.$set('active', currentSelection + 1) :
				app.$set('active', 0);
		}
	},

	/**
	 * Change input on enter key press
	 *
	 * @private
	 * @param {object} e
	 * @returns {boolean}
	 */
	enterKeySelect: function(e) {
		if (e.keyCode === 13) {
			this.setInput(this.searchResultsApp.$get('active'));
		}
	},

	/**
	 * Bind search results click
	 *
	 * @private
	 */
	bindResultsMouseEvent: function() {
		var scope = this;

		$('ref:mapSearchSelect').on('mousedown', function(e, el) {
			scope.setInput($(el).index());
		}, {
			delegate: 'ref:mapSearchResults',
			namespace: 'mapSearch'
		});
	},

	/**
	 * Update search input
	 *
	 * @private
	 * @param {number} i
	 */
	setInput: function(i) {
		var app = this.searchResultsApp;

		$('ref:mapSearchInput').val(app.$get('features')[i].place_name);
		$('ref:mapSearchInput').trigger('change');

		app.$set('selected', i);
	},

	/**
	 * Format geoJSON feature for query
	 *
	 * @private
	 * @param {object} feature
	 * @returns {{context, geometry}}
	 */
	formatFeature: function(feature) {
		return {
			context: JSON.stringify(feature.context),
			geometry: JSON.stringify(feature.geometry),
			placeType: JSON.stringify(feature.place_type),
			properties: JSON.stringify(feature.properties),
			text: feature.text
		};
	},

	/**
	 * Apply error
	 *
	 * @private
	 * @param {string} error
	 */
	applyError: function(error) {
		if (! $('ref:mapSearchFlash').length) {
			var $input = $('ref:mapSearchInput');

			this.searchResultsApp.$set('hidden', true);

			$input.addClass('-has-error')
				.parent()
				.after($.view.render('idento-map.flash', error));

			$.setRef();
		}
	},

	/**
	 * Clear error
	 *
	 * @private
	 */
	clearError: function() {
		var $input = $('ref:mapSearchInput'),
			$flash = $('ref:mapSearchFlash'),
			hasError = '-has-error';

		if ($flash.length && $input.hasClass(hasError)) {
			$input.removeClass(hasError);

			$flash.remove();
		}
	},

	/**
	 * Query for locations
	 *
	 * @private
	 */
	queryForLocations: function() {
		var scope = this,
			app = scope.searchResultsApp;

		scope.toggleLoadingState(true);

		Wee.api.get({
			url: 'ajax/get-locations',
			data: scope.formatFeature(app.$get('features')[app.$get('selected')]),
			success: function(response) {
				var error = response.error,
					success = response.success;

				scope.toggleLoadingState(false);

				if (error) {
					scope.applyError(error);
				}

				if (success) {
					if ($.screen.size() > 2) {
						scope.updateMap(success.locations);
					}

					scope.updateLocations(success);
				}
			},
			error: function(xhr) {
				scope.toggleLoadingState(false);

				scope.applyError(scope.formatStatusText(xhr.statusText));
			}
		});
	},

	/**
	 * Toggling loader and clear button
	 *
	 * @private
	 * @param {boolean} loading
	 */
	toggleLoadingState: function(loading) {
		var $clear = $('ref:mapSearchClear'),
			$loader = $('ref:mapSearchLoader');

		if (loading) {
			$clear.hide();
			$loader.show();
		} else {
			$loader.hide();
			$clear.show();
		}
	},

	/**
	 * Format xhr status text
	 *
	 * @param {string} text
	 * @returns {string}
	 */
	formatStatusText: function(text) {
		return (text ? text : 'Something went wrong') + '. Please try again.';
	},

	/**
	 * Post to map page for results
	 *
	 * @private
	 */
	postForLocations: function() {
		var scope = this,
			app = this.searchResultsApp,
			features = app.$get('features');

		scope.toggleLoadingState(true);

		Wee.history.go({
			path: '/locations',
			request: {
				method: 'post',
				type: 'form',
				data: $.extend(app.$get(), {
					features: JSON.stringify(features),
					inputVal: features[app.$get('selected')].place_name
				}),
				success: function() {
					scope.toggleLoadingState(false);
				}
			}
		});
	}
});